const insertBackToTop = () => {
  const pageIdentifier = document.querySelector('#page-type-identifier');
  if (pageIdentifier && pageIdentifier.getAttribute('data-page-type') === 'PAGE_TYPE_ITEM') {
    const entryWrapper = document.querySelector('.entry-wrapper');

    if (entryWrapper) {
      const backToTopButton = document.createElement('button');
      const arrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="14.897" height="20.84" viewBox="0 0 14.897 20.84">
      <path id="Path_92" data-name="Path 92" d="M1.558,7.346,6.892,1.77V20.84H8V1.77l5.334,5.576L14.9,7.331,7.85,0h-.8L0,7.331Z" transform="translate(14.897 20.84) rotate(180)" fill="#7e71ff"></path>
      </svg>`;
      backToTopButton.classList.add('back-to-top');
      backToTopButton.appendChild(document.createTextNode('Back to top'));
      backToTopButton.innerHTML += arrowSVG;
      backToTopButton.addEventListener('click', (e) => {
        scroll(0, 0);
      });
      entryWrapper.appendChild(backToTopButton);
    }
  }
};

module.exports = {
  insertBackToTop,
};



// WEBPACK FOOTER //
// ./scriptPartials/insertBackToTop.js